var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"block"},[_c('v-switch',{staticClass:"noneDetails",attrs:{"color":"#277faf"},model:{value:(_vm.check),callback:function ($$v) {_vm.check=$$v},expression:"check"}}),_c('EmployeeIcon',{class:{ active: _vm.check }})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }